import React, { useState } from 'react';
import companiesService from '../../services/companies';
import loaderIcon from '../../assets/loader.svg';
import PrimaryButton from '../../components/Layout/PrimaryButton';
import editIcon from '../../assets/edit-icon.png';
import MaskInput from '../../components/Layout/MaskInput/MaskInput';
import Utils from '../../components/Utils/Utils';

import ModalCompanies from '../../components/ModalCompanies';

import './Companies.scss';

const Companies = () => {
  const initialFields = {
    name: { value: '', valid: true, validationMessage: '' },
    cnpj: { value: '', valid: true, validationMessage: '' },
    isActive: { value: true, valid: true, validationMessage: '' },
    comments: { value: '', valid: true, validationMessage: '' },
  };

  const [fields, setFields] = useState({ ...initialFields });
  const [loader, setLoader] = useState(false);
  const [backendError, setBackendError] = useState('');
  const [successForm, setSuccessForm] = useState(false);
  const [companiesList, setCompaniesList] = useState(false);
  const [editCompany, setEditCompany] = useState(false);

  const handleCnpjChange = (maskData) => {
    setFields((prevFields) => ({
      ...prevFields,
      cnpj: {
        ...prevFields.cnpj,
        value: maskData.formattedValue,
      },
    }));
  };

  const handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    setFields((prevFields) => ({
      ...prevFields,
      [name]: {
        ...prevFields[name],
        value: value,
      },
    }));
  };

  const generateRandomCNPJ = () => {
    const randomNumbers = () => Math.floor(Math.random() * 99999999).toString().padStart(8, '0');
    const randomPart = randomNumbers() + randomNumbers();
    return `${randomPart.substring(0, 2)}.${randomPart.substring(2, 5)}.${randomPart.substring(5, 8)}/${randomPart.substring(8, 12)}-${randomPart.substring(12, 14)}`;
  };  

  const saveCompany = async (companyData) => {
    try {
      if (!editCompany) {
        await companiesService.createCompany({ ...companyData });
      } else {
        await companiesService.updateCompany(companyData.companyID, companyData);
      }
      setSuccessForm(true);
      setBackendError('');
    } catch (error) {
      console.error('Error fetching expenses:', error);
      setBackendError('Algo deu errado! Tente novamente.');
    } finally {
      setLoader(false);
    }
  };

  const handleCloseModal = (e) => {
    setCompaniesList(false);
  }

  const handleCompanyChange = async (data) => {
    setFields((prevFields) => ({
      comments: {
        ...prevFields['comments'],
        value: data.comments,
      },
      name: {
        ...prevFields['name'],
        value: data.name,
      },
      cnpj: {
        ...prevFields['cnpj'],
        value: data.cnpj || '',
      },
      companyID: {
        ...prevFields['companyID'],
        value: data.companyID,
      },
      isActive: {
        ...prevFields['isActive'],
        value: data.isActive,
      }
    }));
    setCompaniesList(false);
    setEditCompany(true);
  }

  const validateCompanyName = (name) => {
    return name.trim() !== '';
  };

  const validateForm = () => {
    const isNameValid = validateCompanyName(fields.name.value);
    const cnpjDigits = fields.cnpj.value.replace(/[^\d]/g, '');
    const isCnpjValid = cnpjDigits.length === 0
      || (cnpjDigits.length === 11 && Utils.isValidCPF(cnpjDigits))
      || (cnpjDigits.length === 14 && Utils.isValidCNPJDigits(cnpjDigits));

    setFields((prevFields) => ({
      ...prevFields,
      name: {
        ...prevFields['name'],
        valid: fields.name.value.length > 2,
      },
      cnpj: {
        ...prevFields['cnpj'],
        valid: isCnpjValid,
        validationMessage: isCnpjValid ? '' : 'CNPJ/CPF inválido. Use o formato XX.XXX.XXX/XXXX-XX ou XXX.XXX.XXX-XX',
      },
    }));

    if (!isNameValid || !isCnpjValid) {
      setLoader(false);
      return false;
    } else {
      setBackendError('');
    }

    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoader(true);
    const formData = {};
    Object.entries(fields).forEach(([fieldName, fieldData]) => {
      formData[fieldName] = fieldData.value;
    });

    try {
      await saveCompany(formData);
      setSuccessForm(true);
    } catch (error) {
      console.error('Error saving companie:', error);
      setBackendError('Algo deu errado! Tente novamente.');
    } finally {
      setLoader(false);
    }
  };

  const resetForm = () => {
    setFields({ ...initialFields });
    setLoader(false);
    setBackendError('');
    setSuccessForm(false);
    setEditCompany(false);
  };

  return (
    <>
      {companiesList && (
        <ModalCompanies onCloseModal={handleCloseModal} companyData={handleCompanyChange} />
      )}

      <div className='companies-screen wrapper-content form-box'>
        {!backendError && !successForm && (
          <>
            {editCompany && (
              <button className="back-button" onClick={(e) => { e.preventDefault(); setLoader(true); window.location.reload(); }} style={{ background: 'none', border: 'none', cursor: 'pointer', position: 'absolute', left: 10, top: 15 }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            )}
            <h2>{!editCompany ? 'Cadastro de Empresa' : 'Editar Empresa'}</h2>
            <button className='editSup' onClick={() => setCompaniesList(true)}><img src={editIcon} alt="Edit icon" style={{ width: '18px', height: '18px' }} /></button>
          </>
        )}

        {backendError && (
          <>
            <h2 className="error-message">
              {backendError}
            </h2>
            <PrimaryButton fullWidth onClick={resetForm}>
              Voltar
            </PrimaryButton>
          </>
        )}

        {!backendError && successForm && (
          <div style={{ width: '60%', margin: '0 auto' }}>
            <h2>{!editCompany ? 'Cadastro realizado no sistema!' : 'Edição realizada com sucesso!'}</h2>
            <PrimaryButton fullWidth onClick={resetForm}>
              Voltar
            </PrimaryButton>
          </div>
        )}

        {loader && !backendError && !successForm ? (
          <img src={loaderIcon} alt="Carregando..." width={100} height={100} />
        ) : (
          !successForm && (
            <form onSubmit={handleSubmit} className="companies-screen__form" action="#">
              <label>
                Nome<sup>*</sup>
                <input
                  type="text"
                  name='name'
                  className={fields.name.valid === false ? 'has-error' : ''}
                  onChange={handleInputChange}
                  defaultValue={fields.name.value}
                  tabIndex={1}
                  onBlur={(e) => {
                    validateForm();
                  }}
                />
              </label>
              
              <label>
                Ativo<sup></sup>
                <input
                  align="left"
                  type="checkbox"
                  name="isActive"
                  checked={fields.isActive.value}
                  onChange={handleInputChange}
                  tabIndex={2}
                />
              </label>

              <label>
                CNPJ/CPF
                <MaskInput
                  type='cnpj_cpf'
                  onValueChange={handleCnpjChange}
                  defaultValue={fields.cnpj.value}
                  placeholder="000.000.000-00 ou 00.000.000/0000-00"
                  tabIndex={3}
                  className={fields.cnpj.valid === false ? 'has-error' : ''}
                  onBlur={() => validateForm()}
                />
                {fields.cnpj.valid === false && (
                  <span className="error-message">{fields.cnpj.validationMessage}</span>
                )}
              </label>
              <label>
                Observação
                <textarea
                  name='comments'
                  onChange={handleInputChange}
                  defaultValue={fields.comments.value || ""}
                  tabIndex={6}
                />
              </label>
              <input className={'btn--primary'} type='submit' value={!editCompany ? "Salvar" : "Salvar Edição"} tabIndex={7} />
            </form>
          )
        )}
      </div>
    </>
  );
};

export default Companies;
